<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-xs text-gray-900 align-top">
      {{ dateStartShort }}
    </td>
    <td class="px-4 py-4 text-xs text-gray-900 tabular-nums text-right align-top">
      {{ impressions }}
      <p v-if="$isAdminOrSuperAdmin">{{ costPerMille }}</p>
    </td>
    <td class="px-4 py-4 text-xs text-gray-900 tabular-nums text-right align-top">
      {{ reach }}
      <p v-if="$isAdminOrSuperAdmin">{{ costPerReach }}</p>
    </td>
    <td class="px-4 py-4 text-xs text-gray-900 tabular-nums text-right align-top">
      {{ pageviews }}
      <p v-if="$isAdminOrSuperAdmin" class="whitespace-nowrap">
        {{ pageviewsPerImpression }}% / {{ costPerPageView }}
      </p>
    </td>
    <td class="px-4 py-4 text-xs text-gray-900 tabular-nums text-right align-top">
      {{ contactRequestsCount }}
      <p v-if="$isAdminOrSuperAdmin">{{ spendAmountPerContactRequest }}</p>
    </td>
    <td
      v-if="$isAdminOrSuperAdmin"
      class="px-4 py-4 text-xs text-gray-900 tabular-nums text-right align-top"
    >
      {{ spendAmount }}
    </td>
  </tr>
</template>
<script>
import moment from 'moment';
import numbro from '@/utils/numbro';

export default {
  props: {
    insights: {
      type: Object,
      required: true,
    },
  },
  computed: {
    impressions() {
      return numbro(this.insights.impressions).format({
        thousandSeparated: true,
      });
    },
    costPerMille() {
      const spend = this.insights?.spend || 0;
      const impressions = this.insights?.impressions || 0;
      const spendPerImpression = impressions ? 1000 * (spend / impressions) : 0;

      return numbro(spendPerImpression / 100).formatCurrency({
        thousandSeparated: true,
        mantissa: 2,
      });
    },
    reach() {
      return numbro(this.insights.reach).format({
        thousandSeparated: true,
      });
    },
    costPerReach() {
      const spend = this.insights?.spend || 0;
      const reach = this.insights?.reach || 0;
      const spendPerReach = reach ? 1000 * (spend / reach) : 0;

      return numbro(spendPerReach / 100).formatCurrency({
        thousandSeparated: true,
        mantissa: 2,
      });
    },
    clicks() {
      return numbro(this.insights.clicks).format({
        thousandSeparated: true,
      });
    },
    pageviews() {
      return numbro(this.insights.inline_link_clicks).format({
        thousandSeparated: true,
      });
    },
    pageviewsPerImpression() {
      const inlineLinkClicks = this.insights?.inline_link_clicks || 0;
      const impressions = this.insights?.impressions || 0;
      if (!impressions) return 0;
      return numbro((inlineLinkClicks / impressions) * 100).format({
        thousandSeparated: true,
        mantissa: 2,
      });
    },
    costPerPageView() {
      const inlineLinkClicks = this.insights?.inline_link_clicks || 0;
      const spend = this.insights?.spend || 0;
      if (!inlineLinkClicks) return 0;
      return numbro(!inlineLinkClicks ? spend / 100 / inlineLinkClicks : 0).formatCurrency({
        thousandSeparated: true,
        mantissa: 2,
      });
    },
    contactRequestsCount() {
      return numbro(this.insights?.contact_requests_count || 0).format({
        thousandSeparated: true,
      });
    },
    spendAmount() {
      return numbro((this.insights?.spend || 0) / 100).formatCurrency({
        thousandSeparated: true,
        mantissa: 2,
      });
    },
    spendAmountPerContactRequest() {
      const spendPerContactRequest = this.insights.contact_requests_count
        ? (this.insights?.spend || 0) / this.insights.contact_requests_count
        : 0;

      return numbro(spendPerContactRequest / 100).formatCurrency({
        thousandSeparated: true,
        mantissa: 2,
      });
    },
    dateStart() {
      return moment(this.insights.date_start);
    },
    dateStartShort() {
      return this.dateStart.format('DD MMM YYYY');
    },
  },
};
</script>
